<template>
  <div class="page" :class="{'page__has-bar': !readonly}">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.va_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="va_emname">
            <label class="weui-form-preview__label">{{customLabel.va_emname || "请假人"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">{{form.main.va_emname}}
              <router-link
                class="iconfont icon-history"
                :to="{path: '/oa/vacation_list', query:{hq_keyword: form.main.va_emname} }"
              ></router-link>
              <call-mobile :em-id="form.main.va_emid"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="va_department">
            <label class="weui-form-preview__label">{{customLabel.va_department || "部门"}}</label>
            <span class="weui-form-preview__value">{{form.main.va_department}}</span>
          </div>
          <div class="weui-form-preview__item" slot="va_vacationtype">
            <label class="weui-form-preview__label">{{customLabel.va_vacationtype || "假期类型"}}</label>
            <span class="weui-form-preview__value">{{form.main.va_vacationtype}}</span>
          </div>
          <div class="weui-form-preview__item" slot="va_startime">
            <label class="weui-form-preview__label">{{customLabel.va_startime || "开始时间"}}</label>
            <span
              class="weui-form-preview__value"
              v-format="'yyyy-MM-dd hh:mm'"
            >{{form.main.va_startime}}</span>
          </div>
          <div class="weui-form-preview__item" slot="va_endtime">
            <label class="weui-form-preview__label">{{customLabel.va_endtime || "结束时间"}}</label>
            <span
              class="weui-form-preview__value"
              v-format="'yyyy-MM-dd hh:mm'"
            >{{form.main.va_endtime}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.va_alltimes" slot="va_alltimes">
            <label class="weui-form-preview__label">{{customLabel.va_alltimes || "请假时长"}}</label>
            <span class="weui-form-preview__value">{{form.main.va_alltimes}}</span>
          </div>
          <div class="weui-form-preview__item" slot="va_remark">
            <label class="weui-form-preview__label">{{customLabel.va_remark || "请假原因"}}</label>
            <span class="weui-form-preview__value">{{form.main.va_remark}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.va_agent" slot="va_agent">
            <label class="weui-form-preview__label">{{customLabel.va_agent || "代理人"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">{{form.main.va_agent}}
              <call-mobile :em-id="form.main.va_agentid"></call-mobile>
            </span>
          </div>
        </custom-layout>
      </div>

      <file-list v-model="form.main.va_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/oa/vacation_edit?id='+form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
      >编辑</router-link>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
      >审核</a>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
      >删除</a>
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
      >反审</a>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import CallMobile from "@/components/button/CallMobile.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
    CallMobile
  },
  data() {
    return {
      baseUrl: "/api/oa/vacation",
      codeField: "va_code",
      statusField: "va_statuscode",
      caller: "Vacation",
      xtype: "oa-vacation-formpanel",
    };
  }
};
</script>